import UAuth from '@uauth/js'
console.log('my app ')
const uauth = new UAuth({
  clientID: "e8af4509-3c02-4ff6-bec5-d3af71e43f27",
  redirectUri: "https://beemee.buzz/register",
  scope: "openid wallet messaging:notifications:optional"
})

window.loginWithUnstoppable = async () => {
  try {
    console.log('loginWithUnstoppable');
    const authorization = await uauth.loginWithPopup();
    console.log(authorization);
    return authorization;
  } catch (error) {
    console.error(error)
    return null;
  }
}
